module.exports = __webpack_public_path__ + "static/media/rankb.068b8a0f.png";